<template>
  <div>
    <el-row class="cs-search-conditions" :gutter="20">
      <el-col :span="4">
        <el-select placeholder="课程类型" size="medium" :disabled="loading" v-model="searchCondition.courseType" @change="onCourseTypeChange">
          <el-option v-for="item in scPreloadData.courseTypeItems" :key="item.value" :label="item.desc" :value="item.value" />
        </el-select>
      </el-col>
      <div class="cs-content-group" v-if="searchCondition.courseType === GLOBAL.courseType.university">
        <el-col :span="4">
          <el-select placeholder="学校" size="medium" :disabled="loading" v-model="searchCondition.groupNumber" @change="onGroupNumberChange">
            <el-option v-for="item in scPreloadData.universityGroups" :key="item.IdValue" :label="item.NameValue" :value="item.GroupNumber" />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select placeholder="学期" size="medium" :disabled="loading" v-model="searchCondition.termId" @change="onTermIdChange">
            <el-option v-for="item in scPreloadData.termList" :key="item.Id" :label="item.DisplayLable" :value="item.Id" />
          </el-select>
        </el-col>
      </div>
      <div class="cs-content-group" v-if="searchCondition.courseType === GLOBAL.courseType.vocationalTraining">
        <el-col :span="4">
          <el-select placeholder="职业类型" size="medium" :disabled="loading" v-model="searchCondition.trainingCourseCategory"
            @change="onTrainingCourseCategoryChange">
            <el-option v-for="item in scPreloadData.trainingCourseCategories" :key="item.Id" :label="item.Name" :value="item.Id" />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select placeholder="学期" size="medium" :disabled="loading" v-model="searchCondition.trainingTermId" @change="onTrainingTermIdChange">
            <el-option v-for="item in trainingTermList" :key="item.Id" :label="item.DisplayLable" :value="item.Id" />
          </el-select>
        </el-col>
      </div>
      <!-- <el-col :span="3" class="padding-left-20px">
        <el-checkbox size="medium" :disabled="loading" v-model="searchCondition.isVideoCourseRemoved" class="cs-isVideoCourseRemoved"
          @change="onisVideoCourseRemovedChange">去除视频课</el-checkbox>
      </el-col> -->
      <el-col :span="4" :offset="8" class="cs-signInQuery-buttons">
        <el-button type="primary" :disabled="loading" size="medium" @click="onSearch">搜索</el-button>
      </el-col>
    </el-row>
    <el-row class="cs-search-conditions" :gutter="20">
      <el-col :span="4">
        <el-select placeholder="老师" size="medium" :disabled="loading" filterable v-model="searchCondition.teacherId" @change="onTeacherIdChange">
          <el-option label="所有老师" :value="0" />
          <el-option v-for="item in termTeacherList" :key="item.Id" :label="item.Name" :value="item.Id" />
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-select placeholder="课程" size="medium" :disabled="loading" filterable v-model="searchCondition.courseId" @change="onCourseIdChange">
          <el-option label="所有课程" :value="0" />
          <el-option v-for="item in courseList.filter(course => !searchCondition.teacherId || course.TeacherIds.contains(searchCondition.teacherId))"
            :key="item.Id" :label="item.Name" :value="item.Id" />
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-select placeholder="所有(状态)" size="medium" :disabled="loading" filterable v-model="searchCondition.hasWarning">
          <el-option label="所有(状态)" :value="-1" />
          <el-option label="正常" :value="0" />
          <el-option label="标红" :value="1" />
        </el-select>
      </el-col>
      <el-col :span="5">
        <el-select class="week" placeholder="所有周" size="medium" :disabled="loading" multiple collapse-tags v-model="searchCondition.weeks"
          @change="onWeekChange">
          <el-option v-for="item in weekList" :key="item.Week" :label="item.Label" :value="item.Week" />
        </el-select>
      </el-col>
    </el-row>

    <el-row class="sign-table-container">
      <el-table ref="tblMain" max-height="600" :data="signInListData.Results" v-loading="loading" stripe style="width: 100%; "
        header-row-class-name="el-table-header">
        <el-table-column v-if="signInListData.Results.length > 0" prop="CourseName" label="课程" width="160" header-align="center" align="center" fixed>
          <template slot-scope="scope">
            <el-link v-if="canGotoSignManageEdit" type="primary" :underline="false" @click="gotoSignManageEdit(scope.row)">{{scope.row.CourseName}}</el-link>
            <span v-else>{{scope.row.CourseName}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="searchCondition.courseType === GLOBAL.courseType.vocationalTraining && signInListData.Results.length > 0" prop="CampusName"
          label="校区" width="160" header-align="center" align="center" fixed>
          <template slot-scope="scope">
            <span>{{scope.row.CampusName}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="signInListData.Results.length > 0" prop="TeacherName" label="老师" width="160" header-align="center" align="center" fixed>
          <template slot-scope="scope">
            <span>{{scope.row.TeacherName}}</span>
          </template>
        </el-table-column>

        <el-table-column v-for="(week, weekIndex) in signInListData.AdditionalResult.SignInsSummaryWeekList" :key="weekIndex" :render-header="renderWeekHeader"
          :label="`${week.Week}|${week.WeekText}|${week.DateText}`" :width="140 * (week.MaxCourseActivationCount || 1) + 10" header-align="center">
          <template slot-scope="scope">
            <weekCell :data="{courseActivations: getCourseActivations(scope, week.Week)}" />
          </template>
        </el-table-column>
        <el-table-column v-if="signInListData.Results.length > 0" label="所选周总课时" min-width="110" header-align="center" align="center">
          <template slot-scope="scope">
            <div>{{scope.row.TotalCourseMinutes}}</div>
          </template>
        </el-table-column>
        <el-table-column v-if="signInListData.Results.length > 0" label="总计" min-width="160" header-align="center" align="center">
          <template slot-scope="scope">
            <div>出勤率：{{scope.row.AttendRateText}}</div>
            <div>总真实课程时长：{{scope.row.ActualCourseMinutes}}</div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination v-if="paginationOption.displayPagination" class="cs-pagination" background :disabled="loading" :page-sizes="pageSizeList"
        layout="total, sizes, prev, pager, next, jumper" :total="signInListData.RecordCount" :page-size="signInListData.PageSize"
        :current-page="signInListData.CurrentPage" @size-change="pageSizeChange" @current-change="currentPageChange" />
    </el-row>
  </div>
</template>

<script>
import { downloadFile } from "@/config/mUtils";
import { getTrainingTerms, getTermTeachers } from "@/service/common.service";
import { getCoursesInTerm } from "@/service/speedupCourse.service";
import { getWeekList } from "@/service/termManage.service";
import {
  getSignInQueryListForSupervisorPageData,
  exportSignInQueryListForSupervisor,
} from "@/service/signInManage.service";

const defaultValues = {
  signInListData: {
    CurrentPage: 1,
    PageCount: 1,
    PageSize: 100,
    RecordCount: 0,
    Results: [],
    AdditionalResult: {
      SignInsSummaryWeekList: [],
    },
  },
};

import { mixinSignInQuery } from "./mixinSignInQuery";
const mixin_tableMethods = {
  methods: {
    renderWeekHeader(createElement, { column }) {
      let colValues = column.label.split("|");
      let objClass = {
        "header-week": true,
      };
      let objAttrs = {
        week: colValues[0],
      };
      return createElement(
        "div",
        {
          class: objClass,
          attrs: objAttrs,
        },
        [
          createElement("div", [colValues[1]]),
          createElement("div", [colValues[2]]),
        ]
      );
    },
    getCourseActivations(scope, week) {
      let weekData = scope.row.SignInsSummaryWeekDataList.find(
        (item) => item.Week === week
      );
      return !!weekData ? weekData.CourseActivations : [];
    },
    scrollToWeek(week = 1) {
      let tblMain = this.$refs.tblMain;
      if (!!tblMain) {
        tblMain.$nextTick(() => {
          setTimeout(() => {
            let domBodyWrapper = tblMain.bodyWrapper;
            let domWeeks = tblMain.$el.querySelectorAll(
              ".el-table__header-wrapper .header-week"
            );
            let scrollLeft = 0;
            for (let i = 0; i < domWeeks.length; i++) {
              let domWeek = domWeeks[i];
              let domWeekValue = `${domWeek.getAttribute("week")}`.toNumber();
              if (domWeekValue >= week) break;

              scrollLeft += domWeek.scrollWidth;
            }

            if (scrollLeft > 0) domBodyWrapper.scrollTo(scrollLeft, 0);
          }, 500);
        });
      }
    },
  },
};

export default {
  name: "signInQueryList4",
  mixins: [mixinSignInQuery, mixin_tableMethods],
  components: {
    weekCell: () => import("./signInQueryList4/weekCell"),
  },
  props: {
    colOptions: {
      type: Object,
      default: function () {
        return {
          lgSize: 5,
          mdSize: 8,
          smSize: 24,
        };
      },
    },
    queryType: {
      type: String,
      required: true,
    },
    scPreloadData: {
      type: Object,
      default: () => {
        return {
          defaultValues: {},
          termList: [],
          universityGroups: [],
          trainingCourseCategories: [],
        };
      },
    },
    paginationOption: {
      typeof: Object,
      default: () => {
        return {
          displayPagination: false,
          hasEditButton: false,
          editButtonText: String.empty,
          hasAddButton: false,
          addButtonText: String.empty,
          hasSearch: false,
          editColumnTite: String.empty,
          showAcitveColor: true,
          hideDisableRow: true,
        };
      },
    },
  },
  data() {
    return {
      loading: false,
      isDataReady: false,
      pageSizeList: [20, 50, 100],
      searchCondition: {
        pageSize: 100,
        pageNumber: 1,
        sortField: null,
        isDesc: false,
        courseType: 1,
        termId: null,
        groupNumber: null,
        trainingCourseCategory: null,
        trainingTermId: null,
        teacherId: 0,
        courseId: 0,
        weeks: [],
        isVideoCourseRemoved: false,
        hasWarning: -1,
      },
      trainingTermList: [],
      termTeacherList: [],
      courseList: [],
      weekList: [],
      signInListData: defaultValues.signInListData,
    };
  },
  computed: {
    canGotoSignManageEdit() {
      return (
        this.USERMANAGER.isAdmin ||
        this.USERMANAGER.isAcademicDirector ||
        this.USERMANAGER.isCampusPresident
      );
    },
    canExport() {
      if (this.queryType !== "4" || !this.isDataReady) return false;

      if (this.signInListData.Results.length === 0) return false;

      return true;
    },
  },
  methods: {
    async loadTrainingTermsFromServer() {
      if (
        this.queryType !== "4" ||
        this.searchCondition.courseType !==
          this.GLOBAL.courseType.vocationalTraining
      )
        return;

      let result = await getTrainingTerms(
        false,
        this.searchCondition.trainingCourseCategory
      );
      this.trainingTermList = !!result && result.success ? result.data : [];
      if (this.searchCondition._fromStore) return;

      let currentTerm = null;
      if (this.trainingTermList.length > 0) {
        currentTerm = this.trainingTermList.find((i) => i.IsCurrentTerm);
        if (!currentTerm) currentTerm = this.trainingTermList[0];
      }
      this.searchCondition.trainingTermId = !!currentTerm
        ? currentTerm.Id
        : null;
    },
    async loadTermTeachersFromServer() {
      if (this.queryType !== "4") return;

      let termId =
        this.searchCondition.courseType !==
        this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.termId
          : this.searchCondition.trainingTermId;

      let groupNumber =
        this.searchCondition.courseType !==
        this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.groupNumber
          : null;

      let result = await getTermTeachers(termId, groupNumber);
      this.termTeacherList = !!result && result.success ? result.data : [];
      if (this.searchCondition._fromStore) return;

      this.searchCondition.teacherId = 0;
    },
    async loadCoursesInTermFromServer() {
      if (this.queryType !== "4") return;

      let courseType = this.searchCondition.courseType;
      let termId =
        courseType !== this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.termId
          : this.searchCondition.trainingTermId;
      let universityGroup =
        courseType !== this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.groupNumber
          : 0;

      let result = await getCoursesInTerm(termId, universityGroup, courseType);
      let courseList = !!result && result.success ? result.data : [];
      this.courseList = courseList;
      if (this.searchCondition._fromStore) return;

      this.searchCondition.courseId = 0;
    },
    async loadTermWeekListFromServer() {
      if (this.queryType !== "4") return;

      let termId =
        this.searchCondition.courseType !==
        this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.termId
          : this.searchCondition.trainingTermId;

      let result = await getWeekList(termId, false, true);
      let weekList = !!result && result.success ? result.data : [];
      let currentWeekIndex = weekList.findIndex((item) => item.IsCurrent);
      if (currentWeekIndex >= 0)
        weekList = weekList.filter((item, index) => index <= currentWeekIndex);
      this.weekList = weekList;
      if (this.searchCondition._fromStore) return;

      let weeks = [];
      if (currentWeekIndex >= 0) {
        let currentWeekItem = this.weekList[currentWeekIndex];
        weeks = [currentWeekItem.Week];
      }
      this.searchCondition.weeks = weeks;
    },
    async loadSignInQueryListForSupervisorPageDataFromServer() {
      if (this.queryType !== "4") return;

      let courseType = this.searchCondition.courseType;
      let groupNumber =
        this.searchCondition.courseType !==
        this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.groupNumber
          : 0;
      let termId =
        this.searchCondition.courseType !==
        this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.termId
          : this.searchCondition.trainingTermId;
      let teacherId = this.searchCondition.teacherId || null;
      let courseId = this.searchCondition.courseId || null;
      let weeks = this.searchCondition.weeks;

      if (!termId) {
        this.signInListData = defaultValues.signInListData;
        return;
      }

      let condition = {
        PageSize: this.searchCondition.pageSize,
        PageNumber: this.searchCondition.pageNumber,
        SortField: this.searchCondition.sortField,
        IsDesc: this.searchCondition.isDesc,
        KeyWord: null,
        AdditionalFilter: {
          CourseType: courseType,
          UniversityGroup: groupNumber,
          TermId: termId,
          TeacherId: teacherId,
          CourseId: courseId,
          Weeks: weeks,
          IsVideoCourseRemoved: this.searchCondition.isVideoCourseRemoved,
          HasWarning: this.searchCondition.hasWarning,
        },
      };

      this.loading = true;
      try {
        let result = await getSignInQueryListForSupervisorPageData(condition);
        let defaultSignInListData = Object.clone(defaultValues.signInListData);
        let newSignInListData =
          !!result && result.success ? result.data : defaultSignInListData;
        defaultSignInListData.RecordCount = newSignInListData.RecordCount;
        defaultSignInListData.PageSize = newSignInListData.PageSize;
        this.signInListData = defaultSignInListData;

        this.$nextTick(() => {
          this.signInListData = newSignInListData;

          this.searchCondition.pageSize = this.signInListData.PageSize;
          this.searchCondition.pageNumber = this.signInListData.CurrentPage;

          this.updateSignInQueryAll({
            queryType: this.queryType,
            searchCondition: this.searchCondition,
          });

          let currentWeek = this.weekList.find((item) => item.IsCurrent);
          let weekNum = !!currentWeek ? currentWeek.Week : 1;
          this.scrollToWeek(weekNum);
        });
      } catch (error) {
      } finally {
        this.$set(this.searchCondition, "_fromStore", false);
        this.loading = false;
      }
    },
    async exportSignInQueryListFromServer() {
      if (this.queryType !== "4") return;

      let courseType = this.searchCondition.courseType;
      let groupNumber =
        this.searchCondition.courseType !==
        this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.groupNumber
          : 0;
      let termId =
        this.searchCondition.courseType !==
        this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.termId
          : this.searchCondition.trainingTermId;
      let teacherId = this.searchCondition.teacherId || null;
      let courseId = this.searchCondition.courseId || null;
      let weeks = this.searchCondition.weeks;
      let courseCategory =
        this.searchCondition.courseType ===
        this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.trainingCourseCategory
          : 0;

      if (!termId) {
        this.signInListData = defaultValues.signInListData;
        return;
      }

      let condition = {
        PageSize: 0,
        PageNumber: 1,
        SortField: this.searchCondition.sortField,
        IsDesc: this.searchCondition.isDesc,
        KeyWord: null,
        AdditionalFilter: {
          CourseType: courseType,
          UniversityGroup: groupNumber,
          TermId: termId,
          TeacherId: teacherId,
          CourseId: courseId,
          Weeks: weeks,
          IsVideoCourseRemoved: this.searchCondition.isVideoCourseRemoved,
          HasWarning: this.searchCondition.hasWarning,
          CourseCategory: courseCategory,
        },
      };

      this.loading = true;
      let result = await exportSignInQueryListForSupervisor(condition);
      if (!!result && result.success) {
        downloadFile(result);
      }
      this.loading = false;
    },

    async reloadSearchConditionsAndListData() {
      let storeSearchConditionValue = this.storeSearchCondition;
      if (!!storeSearchConditionValue) {
        this.searchCondition = storeSearchConditionValue;
        this.$set(this.searchCondition, "_fromStore", true);
      }

      await this.loadTrainingTermsFromServer();
      await this.loadTermTeachersFromServer();
      await this.loadCoursesInTermFromServer();
      await this.loadTermWeekListFromServer();
      await this.loadSignInQueryListForSupervisorPageDataFromServer();
      this.isDataReady = true;
    },
    onCourseTypeChange() {
      this.$nextTick(async () => {
        await this.loadTrainingTermsFromServer();
        await this.loadTermTeachersFromServer();
        await this.loadCoursesInTermFromServer();
        await this.loadTermWeekListFromServer();
      });
    },
    onGroupNumberChange() {
      this.$nextTick(async () => {
        await this.loadTermTeachersFromServer();
        await this.loadCoursesInTermFromServer();
        await this.loadTermWeekListFromServer();
      });
    },
    onTermIdChange() {
      this.$nextTick(async () => {
        await this.loadTermTeachersFromServer();
        await this.loadCoursesInTermFromServer();
        await this.loadTermWeekListFromServer();
      });
    },
    onTrainingCourseCategoryChange() {
      this.$nextTick(async () => {
        await this.loadTrainingTermsFromServer();
        await this.loadTermTeachersFromServer();
        await this.loadCoursesInTermFromServer();
        await this.loadTermWeekListFromServer();
      });
    },
    onTrainingTermIdChange() {
      this.$nextTick(async () => {
        await this.loadTermTeachersFromServer();
        await this.loadCoursesInTermFromServer();
        await this.loadTermWeekListFromServer();
      });
    },
    onTeacherIdChange() {
      this.searchCondition.courseId = 0;
    },
    onCourseIdChange() {},
    onWeekChange() {},
    onisVideoCourseRemovedChange() {},
    async onSearch() {
      this.searchCondition.pageNumber = 1;
      await this.loadSignInQueryListForSupervisorPageDataFromServer();
    },
    pageSizeChange(value) {
      this.searchCondition.pageSize = value;
      this.onSearch();
    },
    currentPageChange(value) {
      this.searchCondition.pageNumber = value;
      this.loadSignInQueryListForSupervisorPageDataFromServer();
    },
    gotoSignManageEdit(row) {
      let courseId = row.CourseId;
      let courseName = row.CourseName;
      let teacherId = row.TeacherId;
      let teacherName = row.TeacherName;
      let campusId = row.CampusId;
      let campusName = row.CampusName;
      let status = row.Active;
      let groupNumber =
        this.searchCondition.courseType !==
        this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.groupNumber
          : 0;
      let termId =
        this.searchCondition.courseType !==
        this.GLOBAL.courseType.vocationalTraining
          ? this.searchCondition.termId
          : this.searchCondition.trainingTermId;

      let query = {
        back: "signInQueryList4",
        groupNumber,
        termId,
        teacherId,
        courseId,
        courseName,
        teacherName,
        status,
        usage: "universityTutorial",
      };
      if (
        this.searchCondition.courseType ===
        this.GLOBAL.courseType.vocationalTraining
      ) {
        query.usage = "vocationalTraining";
        query.campusId = campusId;
        query.campusName = campusName;
      }

      this.$router.push({
        path: "/admin/signInManageEdit",
        query,
      });
    },
  },
  watch: {
    queryType(newValue, oldValue) {
      if (newValue == "4") {
        if (this.isDataReady) {
          this.updateSignInQueryAll({
            queryType: newValue,
            searchCondition: this.searchCondition,
          });
          return;
        } else {
          this.updateQueryType(newValue);
        }
      } else {
        return;
      }

      this.$nextTick(async () => {
        await this.reloadSearchConditionsAndListData();
      });
    },
    scPreloadData(newValue, oldValue) {
      Object.copy(
        this.searchCondition,
        { onlyFieldExists: true },
        newValue.defaultValues
      );

      if (this.queryType != "4") return;

      this.$nextTick(async () => {
        await this.reloadSearchConditionsAndListData();
      });
    },
  },
};
</script>
<style lang="scss">
.cs-signInQuery-weekCell {
  word-break: break-word;
}
</style>

<style lang="scss" scoped>
.cs-search-conditions {
  .el-col {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .week {
    min-width: 240px;
    width: calc(100% - 20px);
  }
}

.cs-isVideoCourseRemoved {
  line-height: 36px;
  margin-bottom: 0;
  margin-left: 5px;
}

.sign-table-container {
  margin-top: 10px;

  .el-table {
    /deep/ .el-table__row {
      td {
        padding: 5px 0;

        .cell {
          padding: 0 5px;
        }
      }
    }

    /deep/ .header-week {
      line-height: 22px;
      padding-left: 0;
    }
  }
}

.cs-signInQuery-buttons {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/signInManage/signInQueryList4.vue